/* eslint-disable no-magic-numbers */
import { FormattedMessage } from '@futrli/localisation';
import classNames from 'classnames';
import React from 'react';
import { getRowHeightSize } from '../../user-grid-settings/user-grid-settings-actions';
import { UserGridSettingsContext } from '../../user-grid-settings/user-grid-settings-context';
import { nestedAccountHeightOverride } from '../style-rows';
import { SystemCalcRow } from '../types';
import { MARGIN_LEFT_LEVEL, isInvoiceAssumption, isVatRow } from './header-row-utils';
import grid from '../../../../../ui/data-grid/components/grid.scss';
import { PredictionsAccountCategories, VIEW_TYPES } from '../../../../../core/types';
import { getColors } from '../style-rows';

interface Props {
  isLast?: boolean;
  level: number;
  row: SystemCalcRow;
  wrapperStyle: React.CSSProperties;
  category?: PredictionsAccountCategories;
  viewType?: VIEW_TYPES;
}

export const HeaderRowSystemCalc: React.FC<Props> = React.memo(
  ({ row, level, isLast, wrapperStyle, category, viewType }) => {
    const { rowHeights } = React.useContext(UserGridSettingsContext);
    const rowHeight = getRowHeightSize(rowHeights);

    const assumptionsRowHeightOverride = nestedAccountHeightOverride(row, rowHeight, level);
    const isVat = isVatRow(row);

    const headerRowClasses = classNames({
      [grid.rowHeader]: true,
      [grid.isChild]: true,
      [grid.isLast]: isLast,
      [grid.isFirst]: row.siblingIndex === 0,
      [grid.isInvoiceAssumption]: isInvoiceAssumption(row),
      [grid.isVat]: isVat
    });

    const headerRowInnerClasses = classNames({
      [grid.rowHeaderInner]: true,
      [grid[assumptionsRowHeightOverride]]: true
    });

    return (
      <div className={headerRowClasses} style={wrapperStyle} role="row">
        <div
          className={headerRowInnerClasses}
          style={{
            backgroundColor: getColors(category || 'income', viewType)[2],
            marginLeft: level * MARGIN_LEFT_LEVEL
          }}
          role="cell"
        >
          <div className={classNames(grid.flexContainer, grid.flexContainerJustify)}>
            <div className={grid.title} data-testid="account-name">
              {isVat ? (
                <FormattedMessage id="predict.vat_gst_payment" defaultMessage="VAT / GST payment" />
              ) : (
                row.account.name
              )}
            </div>
            {/* <div style={{ width: 72, borderLeft: '1px solid #F6F7FA', height: '100%' }}></div> */}
          </div>
        </div>
      </div>
    );
  }
);
